import {
  Breadcrumb,
  Button,
  Card,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Radio,
  Select,
  Upload,
} from "antd";
import React, { useState, useCallback, useEffect } from "react";
import { useNavigate } from "react-router";
import SendMoneyService from "../../../services/send-money.service";
import { ReactComponent as HomeIcon } from "../../../assests/images/home-line.svg";
import { NumericFormat } from "react-number-format";
import {
  allowDecimalwithMaxLimit,
  allowOnlyAlphaNumerics,
  allowOnlyAlphaNumericsWithSpace,
  allowOnlyAlphabetsWithSpace,
  handlePasteNotAllowSpace,
  amountFormat,
  allowOnlyAlphaNumericsShouldNotStartWithSpace,
  allowOnlyAlphabetsShouldNotStartWithSpace,
} from "../../../services/common.service";
import { useDispatch, useSelector } from "react-redux";
import {
  accountListSelector,
  modeSelector,
  selectedAccountSelector,
} from "../../../store/selectors/app.selector";
import TransferService from "../../../services/transfer.service";
import CommonOtp from "../../../components/otp";
import {
  setAccountList,
  setSelectedAccount,
} from "../../../store/actions/app.action";
import AccountService from "../../../services/accounts.service";
import dayjs from "dayjs";
import AccountDisplay from "../../../components/account-display";
import { CONFIG } from "../../../environment";
import checkedIcon from "../../../assests/images/checked.svg";
import unCheckedIcon from "../../../assests/icons/uncheck.png";
import { ReactComponent as TitleIcon } from "../../../assests/images/quicktbreadrans.svg";
import AccountCard from "../../../components/account-card";
import AccountSelectedCard from "../../../components/account-selected-card";
import { ReactComponent as TickIcon } from "../../../assests/images/tickIcon.svg";
import { useTranslation } from "react-i18next";
import AccountDisplayView from "../../../components/account-display-view";
import { UploadOutlined } from "@ant-design/icons";
import Dragger from "antd/es/upload/Dragger";
import PendingAuthService from "../../../services/approvals.service";
import { VscError } from "react-icons/vsc";

const modeOfTransferList = [
  { label: "SWIFT / BIC", value: "BIC" },
  { label: "IFSC", value: "IFSC" },
  { label: "Routing", value: "ROUTE" },
];
export default function InternationalQuickTransfer() {
  const navigate = useNavigate();
  const [stage, setStage] = useState(1);
  const [visible, setVisible] = useState(false);
  const [verifyDetails, setVerifyDetails] = useState({});
  const [message, setMessage] = useState("");
  const [form] = Form.useForm();
  const accountList = useSelector(accountListSelector);
  const [transferType, setTransferType] = useState("SWIFT");
  const [formDetails, setFormDetails] = useState({
    addBene: false,
    hasFxDeal: false,
    paymentType: "ONCE",
    paymentSubType: "Pay_Now",
  });
  const [cancelVisible, setCancelVisible] = useState(false);
  const [respDetails, setRespDetails] = useState({});
  const [modeOfTransfer, setModeOfTransfer] = useState("BIC");
  const dispatch = useDispatch();
  const mode = useSelector(modeSelector);
  const [metaData, setMetaData] = useState({
    frequency: [],
    maximumInstallments: [],
    paymentTypes: {},
    transferTypes: {},
    internationalFileUploadSize: "",
  });
  const [isErrorModalVisible, setIsErrorModalVisible] = useState(false);
  const [validate, setValidate] = useState(false);
  const selectedAccount = useSelector(selectedAccountSelector);
  const [addBene, setAddBene] = useState(false);
  const [accountDetails, setAccountDetails] = useState({});
  const [fspCodesList, setFspCodesList] = useState([]);
  const [fspFilteredList, setFspFilteredList] = useState([]);
  const [selectedFspBank, setSelectedFspBank] = useState({});
  const [convertedAmount, setConvertedAmount] = useState({});
  const [hasFxDeal, setHasFxDeal] = useState(false);
  const [selectedTxnCcy, setSelectedTxnCcy] = useState();
  const [otp, setOtp] = useState("");
  const [successVisible, setSuccessVisible] = useState(false);
  const { t } = useTranslation();
  const [paymentType, setPaymentType] = useState("ONCE");
  const [paymentSubType, setPaymentSubType] = useState("Pay_Now");
  const [countryCodeList, setCountryCodeList] = useState([]);
  const [txnCurrencyList, setTxnCurrencyList] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [uploadFile, setUploadFile] = useState("");
  const [allFiles, setAllFiles] = useState([]);
  const [modifyVisible, setModifyVisible] = useState(false);
  const [swiftCodeValues, setSwiftCodeValues] = useState([]);
  const [updatedSwiftCodeValues, setUpdatedSwiftCodeValues] = useState([]);
  const [swiftBankNameValues, setSwiftBankNameValues] = useState([]);
  const [swiftCountries, setSwiftCountries] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [swiftModalVisible, setSwiftModalVisible] = useState(false);
  const [swiftFilteredBank, setSwiftFilteredBank] = useState([]);
  const [checkedIndex, setCheckedIndex] = useState(null);
  const [swiftForm] = Form.useForm();
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (accountList?.length > 0) {
      setConvertedAmount({});
      form.resetFields(["amount"]);
    }
  }, [accountList, selectedAccount, transferType]);

  useEffect(() => {
    form.setFieldsValue({ amount: "" });
}, [selectedAccount]);

  useEffect(() => {
    getFspCodes();
    getAllCountryCodes();
    getTxnCurrency();
    transferOptions();
  }, []);

  const getTxnCurrency = useCallback(async () => {
    try {
      const reqParams = {
        transferType: "SWIFT",
      };
      const response = await TransferService.getTxnCurrency(reqParams);
      if (response.status === 200) {
        setTxnCurrencyList(response.data["data"]);
        // form.setFieldsValue({ txnCcy: CONFIG?.CURRENCY });
      }
    } catch (error) {}
  }, []);

  const getFspCodes = useCallback(async () => {
    try {
      const response = await TransferService.getFspCodes();
      if (response.status === 200) {
        setFspCodesList(response.data["fspDetails"]);
        setFspFilteredList(
          response.data["fspDetails"].filter((ele) => ele.fspType === "BANK")
        );
      }
    } catch (error) {}
  }, [modeOfTransfer]);

  const getAllCountryCodes = useCallback(async () => {
    try {
      const response = await SendMoneyService.getAllCountryCodes();
      if (response.status === 200) {
        setCountryCodeList(response.data["countryCodeList"]);
      }
    } catch (error) {}
  }, []);

  const transferOptions = useCallback(async () => {
    try {
      const response = await SendMoneyService.transferOptions();
      if (response.status === 200) {
        setMetaData(response.data["data"]);
      }
    } catch (error) {}
  }, []);

  const onChange = useCallback(
    (info) => {
      if (info.file.status === "done") {
        const fileSize =
          parseFloat(
            metaData?.internationalFileUploadSize.replace(/[^0-9.]/g, "")
          ) *
          1024 *
          1024;
        if (info.file.size <= fileSize) {
          const uploadedFiles = info.fileList.map((file) => file.originFileObj);
          setUploadFile(uploadedFiles);
        } else {
          setIsErrorModalVisible(true);
        }
      }
    },
    [metaData]
  );

  const onRemove = useCallback(() => {
    setUploadFile("");
  });

  const handleAction = useCallback(({ file, onSuccess }) => {
    console.log(file);
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  });

  const internationalfileUpload = useCallback(
    async (values) => {
      try {
        if (modifyVisible === false) {
          const srcAccDetails = accountList.find(
            (ele) => ele.accountNo === selectedAccount.accountNo
          );
          const req = {
            files: uploadFile,
            srcAcct: srcAccDetails.accountNo,
            accountName: srcAccDetails?.accountName,
            srcAccName: srcAccDetails?.accountName,
          };
          const response = await TransferService.internationalfileUpload(req);
          if (response.status === 200) {
            setAllFiles(response.data["data"]["fileNames"]);
            onVerify(values, response.data["data"]["fileNames"]);
          }
        } else {
          onVerify(values);
        }
      } catch (err) {}
    },
    [modifyVisible, uploadFile, accountList, selectedAccount]
  );

  const onVerify = useCallback(
    async (values, fileObj) => {
      try {
        const srcAccDetails = accountList.find(
          (ele) => ele.accountNo === selectedAccount.accountNo
        );

        const transferAmount =
          typeof values.amount === "number"
            ? values.amount
            : parseFloat(values.amount.replaceAll(/,/g, ""));

        const fxdealrates = values?.fxDealRefNo
          ? {
              fxreferencerate: convertedAmount?.convRate || "",
              isfxDealRateAvl: "Y",
            }
          : { fxreferencerate: "", isfxDealRateAvl: "N" };

        const reqParams = {
          srcAcct: srcAccDetails?.accountNo,
          accountName: srcAccDetails?.accountName,
          srcAccName: srcAccDetails?.accountName,
          srcBr: srcAccDetails?.branchId,
          srcCcy: srcAccDetails?.accountCurrency,
          destBr: values?.beneBrn || "",
          destCcy:
            transferType === "IAT"
              ? accountDetails?.accCcy
              : transferType === "SWIFT"
              ? values?.txnCcy
              : CONFIG.CURRENCY,
          destAcct: values?.payeeAccountNo,
          amount: transferAmount,
          narration: values?.remarks || "",
          remarks: values?.remarks || "",
          remarksTag: values?.remarks,
          txnType: transferType,
          quickTransfer: true,
          destBankName: values?.bankName,
          destBankAddr: values.bankAddress,
          destBankCty: values?.bankCountry,
          txnCcy: values?.txnCcy,
          txnDate: dayjs(new Date()),
          chargeBornesBy: "OUR",
          beneName: accountDetails?.customerName || values?.beneName,
          beneMobileNo: "",
          beneMail: "",
          beneAddr: values?.beneAddress,
          beneCountry: values.bankCountry,
          fxDealRefNo: values?.fxDealRefNo || "",
          bicCode: selectedFspBank?.fspCode,
          sortCode: "",
          swiftCode: values?.swiftCode,
          custId: srcAccDetails?.customerId,
          paymentType: paymentType === "ONCE" && paymentSubType === "Pay_Later"
          ? "SCHEDULED"
          : paymentType,
          numberOfInstallments: values?.numberOfInstallment || "",
          customFields: {
            cntrctSetlmtinterOne: values?.intermediaryBic || "",
            isInterMidFlg: values?.intermediaryBank ? "Y" : "N",
            ...fxdealrates,
          },
          payeeId: 0,
          scheduled: paymentType === "ONCE" && paymentSubType === "Pay_Later"
          ? true
          : false,
          addBene: addBene,
          recurring: paymentType === "RECURRING",
          scheduledDate: values?.frequencyDate
            ? values?.frequencyDate.format("YYYY-MM-DD")
            : "",
          frequency: values?.frequency || "",
          modeOfTransfer: modeOfTransfer || "",
          bulkTransfer: false,
          fileNames:
            fileObj !== undefined && fileObj.length > 0 ? fileObj : allFiles,
        };
        setFormDetails(reqParams);
        setStage(2);
      } catch (error) {
        console.log("erroe", error);
      }
    },
    [
      accountList,
      metaData,
      accountDetails,
      selectedAccount,
      selectedFspBank,
      addBene,
      transferType,
      paymentSubType,
      paymentType,
      allFiles,
      convertedAmount,
    ]
  );

  const handleSearchAndFilterChange = useCallback(
    (value) => {
      setSearchText(value);
      let filteredData;
      if (value === "") {
        filteredData = updatedSwiftCodeValues;
      } else {
        filteredData = updatedSwiftCodeValues.filter((item) => {
          const swiftCodes = item.swiftCode.toLowerCase();
          const searchLower = value.toLowerCase();
          const isMatch = swiftCodes.includes(searchLower);
          return isMatch;
        });
      }
      setSwiftCodeValues(filteredData);
    },
    [swiftCodeValues, updatedSwiftCodeValues]
  );

  const fundTransferVerify = useCallback(async () => {
    try {
      const req = {
        ...formDetails,
        conversionAmount: convertedAmount?.convAmt || "",
        conversionRate: convertedAmount.convRate || "",
      };
      setFormDetails(req);
      const response = await TransferService.fundTransferVerify(req);
      if (response.status === 200) {
        setVerifyDetails(response.data["data"]);

        if (response.data["data"]["otpEnabled"]) {
          setStage(3);
        } else {
          fundTransferConfirm({
            ...req,
            ...{ otp: CONFIG.DEFAULT_OTP },
          });
        }
      }
    } catch (error) {}
  }, [formDetails, convertedAmount]);

  const fundTransferConfirm = useCallback(async (reqParams) => {
    try {
      setFormDetails(reqParams);
      const response = await TransferService.fundTransferConfirm(reqParams);
      if (response.status === 200) {
        dispatch(setAccountList([]));
        setRespDetails({
          message: response.data?.message,
          ...response.data["data"],
        });
        await fetchAccounts();
        setSuccessVisible(true);
      }
    } catch (error) {
      setOtp("");
      if (["TG-USR-40025", "TG-USR-40026"].indexOf(error.data.code) < 0) {
        setStage(1);
      }
    }
  }, []);

  const fetchAccounts = useCallback(async () => {
    try {
      const response = await AccountService.getQuickAccounts("BA");
      if (response.status === 200) {
        const selectedAccountDetails =
          response?.data["data"]["accounts"].find(
            (ele) => ele.primaryAccount === true
          ) ||
          response.data["data"]["accounts"][0] ||
          [];
        dispatch(setSelectedAccount(selectedAccountDetails));
      }
    } catch (error) {}
  }, []);

  const onfspBankChange = (value) => {
    setSelectedFspBank(fspCodesList.find((e) => e.fspCode === value));
  };

  const getConvertedAmount = useCallback(async () => {
    try {
      if (CONFIG?.CROSS_CURRENCY === false) {
        return;
      }
      const { amount, txnCcy, fxDealRefNo } = form.getFieldsValue();
      setSelectedTxnCcy(txnCcy);
      const transferAmount =
        typeof amount === "number"
          ? amount
          : parseFloat(amount.replaceAll(/,/g, ""));
      const reqParams = {
        srcCcy: selectedAccount?.accountCurrency,
        destCcy:
          transferType === "SWIFT"
            ? txnCcy
            : accountDetails?.accCcy || CONFIG.CURRENCY,
        txnCcy: txnCcy,
        txnType: transferType,
        amount: transferAmount,
        fxDealRefNo: fxDealRefNo,
        srcAcct: selectedAccount?.accountNo,
        accountName: selectedAccount?.accountName,
        srcAccName: selectedAccount?.accountName,
      };
      if (txnCcy === selectedAccount?.accountCurrency) {
        return;
      }
      const response = await TransferService.getConvertedAmount(reqParams);
      if (response.status === 200) {
        setConvertedAmount(response.data["data"]);
      }
    } catch (error) {}
  }, [selectedAccount, accountDetails, transferType]);

  const handleSelectChange = (selectedValue) => {
    const selectedBranch = countryCodeList.find(
      (option) => option.countryName === selectedValue
    );
    setSelectedOption(selectedBranch);
  };

  const getSwiftCountryList = useCallback(async () => {
    try {
      const response = await TransferService.swiftCountryLookUp();
      if (response.status === 200) {
        setSwiftCountries(response?.data["swiftCountryList"]);
        setSwiftModalVisible(true);
      }
    } catch (error) {}
  }, []);

  const getSwiftCodeLookUp = useCallback(async (e) => {
    try {
      swiftForm.resetFields(["swiftBank", "allCode"]);
      setSwiftCodeValues([]);
      setIsChecked(false);
      setCheckedIndex(null);
      const reqParams = {
        countryCode: e,
      };
      const response = await TransferService.swiftCodeLookUp(reqParams);
      if (response.status === 200) {
        setSwiftBankNameValues(response?.data["swiftLookUpDeatilsResponse"]);
        const uniqueBankNames = new Set();
        const filteredData = response?.data[
          "swiftLookUpDeatilsResponse"
        ].filter((entry) => {
          if (!uniqueBankNames.has(entry.bankName)) {
            uniqueBankNames.add(entry.bankName);
            return true;
          }
          return false;
        });
        setSwiftFilteredBank(filteredData);
      }
    } catch (error) {}
  }, []);

  const handleToggleCheck = (idx, value) => {
    if (checkedIndex === idx) {
      setCheckedIndex(null);
    } else {
      setCheckedIndex(idx);
      const swiftValues = swiftCodeValues.find(
        (ele) => ele.swiftCode === value
      );
      form.setFieldsValue({
        bankName: swiftValues?.bankName,
        bankCountry: swiftValues?.countryName,
        bankAddress: swiftValues?.bankAddress,
        swiftCode: swiftValues?.swiftCode,
      });
    }
  };
  const handleDownload = useCallback(async (selected) => {
    try {
      const reqParams = {
        txnId: selected?.txnId,
      };
      setSuccessVisible(false);

      await PendingAuthService.downloadReceipts(reqParams);
      navigate("/transfer");
    } catch (err) {}
  }, []);

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm();

      case 2:
        return renderConfirm();

      case 3:
        return (
          <CommonOtp
            otp={otp}
            setOtp={setOtp}
            type="TRANSACTION"
            onConfirm={(values) =>
              fundTransferConfirm({ ...formDetails, ...values })
            }
            handleResendOtp={() => fundTransferVerify()}
            cancelTransaction={() => {
              navigate("/transfer");
            }}
          />
        );

      default:
        return renderForm();
    }
  }

  function renderForm() {
    return (
      <>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          {/* <p className="mb-4">Please fill required details, before you proceed</p> */}
          <p>
            {t("pages.fundtransfer.transfer_desc", {
              defaultValue: "Please enter below details",
            })}
          </p>
          <div className="row">
            <div className="d-flex align-items-center">
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <AccountDisplay type="image" />
              </div>
            </div>
          </div>
          <Form
            layout="vertical"
            requiredMark={true}
            form={form}
            onFinish={internationalfileUpload}
            initialValues={formDetails}
            className="internationalform"
          >
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Form.Item
                  label={t("pages.standing_instruction.bene_acc_no", {
                    defaultValue: "Beneficiary Account Number",
                  })}
                  name={"payeeAccountNo"}
                  rules={[
                    {
                      required: true,
                      message: t(
                        "pages.standing_instruction.bene_acc_no_req_txt",
                        {
                          defaultValue:
                            "Beneficiary Account Number is required",
                        }
                      ),
                    },
                    {
                      min: CONFIG?.ACCOUNT_NO_MIN_LENGTH,
                      max: CONFIG?.ACCOUNT_NUMBER_MAX_LENGTH,
                      message: t(
                        "pages.standing_instruction.enter_valid_acc_txt",
                        {
                          defaultValue:
                            "Please enter valid Beneficiary Account Number",
                        }
                      ),
                    },
                  ]}
                >
                  <Input
                    maxLength={CONFIG.ACCOUNT_NUMBER_MAX_LENGTH}
                    onKeyPress={(e) => allowOnlyAlphaNumerics(e)}
                    onPaste={(e) => handlePasteNotAllowSpace(e)}
                    placeholder={t("pages.standing_instruction.bene_acc_no", {
                      defaultValue: "Beneficiary Account Number",
                    })}
                    onInput={() => (validate ? setValidate(false) : null)}
                    size="large"
                  />
                </Form.Item>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Form.Item
                  label={t("pages.Add_Bene.bane_name", {
                    defaultValue: "Beneficiary Name",
                  })}
                  name={"beneName"}
                  rules={[
                    {
                      required: true,
                      message: t("pages.Add_Bene.bene_name_req", {
                        defaultValue: "Beneficiary Name is required",
                      }),
                    },
                  ]}
                >
                  <Input
                    onKeyPress={(e) =>
                      allowOnlyAlphabetsShouldNotStartWithSpace(e)
                    }
                    maxLength={CONFIG.BENE_NICKNAME_LENGTH}
                    placeholder={t("pages.Add_Bene.bane_name", {
                      defaultValue: "Beneficiary Name",
                    })}
                    size="large"
                  />
                </Form.Item>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Form.Item
                  name="beneAddress"
                  label={t("pages.login.address", {
                    defaultValue: "Address",
                  })}
                  rules={[
                    {
                      required: true,
                      message: t("pages.login.address_req", {
                        defaultValue: "Address is required",
                      }),
                    },
                  ]}
                >
                  <Input
                    maxLength={30}
                    placeholder={t("pages.login.address", {
                      defaultValue: "Address",
                    })}
                    size="large"
                  />
                </Form.Item>
              </div>
              {/* <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  name="beneCountry"
                  label="Beneficiary Country"
                  rules={[
                    {
                      required: true,
                      message: "Beneficiary Country is required",
                    },
                  ]}
                >
                  <Select
                    placeholder="Beneficiary Country"
                    bordered={true}
                    size="large"
                    onChange={handleSelectChange}
                  >
                    {countryCodeList.map((option, idx) => (
                      <Select.Option key={idx} value={option.countryName}>
                        {option.countryName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div> */}
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  name="modeOfTransfer"
                  label={t("pages.payment_history.mode_transfer", {
                    defaultValue: "Mode of Transfer",
                  })}
                  rules={[
                    {
                      required: false,
                      message: t("errorMesssages.mode_of_transfer_required", {
                        defaultValue: "Mode Of Transfer is required",
                      }),
                    },
                  ]}
                >
                  <Select
                    placeholder={t("pages.payment_history.mode_transfer", {
                      defaultValue: "Mode of Transfer",
                    })}
                    bordered={true}
                    size="large"
                    onChange={(e) => {
                      setModeOfTransfer(e);
                      form.setFieldsValue({
                        swiftCode: "",
                        bankName: "",
                        bankCountry: "",
                        bankAddress: "",
                      });
                    }}
                    defaultValue="BIC"
                  >
                    {modeOfTransferList.map((option, idx) => (
                      <Select.Option key={idx} value={option.value}>
                        {option.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  name="swiftCode"
                  label={
                    modeOfTransfer === "ROUTE"
                      ? t("pages.Add_Bene.routing_number", {
                          defaultValue: "Routing Number",
                        })
                      : modeOfTransfer === "IFSC"
                      ? t("pages.Add_Bene.ifsc_code", {
                          defaultValue: "IFSC Code",
                        })
                      : t("pages.Add_Bene.swift_or_bic", {
                          defaultValue: "Swift / BIC Code",
                        })
                  }
                  rules={[
                    {
                      required: true,
                      message:
                        modeOfTransfer === "ROUTE"
                          ? t("pages.Add_Bene.routing_num_req", {
                              defaultValue: "Routing Number is required",
                            })
                          : modeOfTransfer === "IFSC"
                          ? t("pages.Add_Bene.ifsc_code_req", {
                              defaultValue: "IFSC Code is required",
                            })
                          : t("pages.Add_Bene.swift_or_bic_req", {
                              defaultValue: "Swift / BIC Code is required",
                            }),
                    },
                  ]}
                >
                  <Input
                    onPaste={(evet) => {
                      evet.preventDefault();
                      return false;
                    }}
                    onClick={() => {
                      if (
                        modeOfTransfer === "ROUTE" ||
                        modeOfTransfer === "IFSC"
                      ) {
                        return;
                      } else {
                        getSwiftCountryList();
                      }
                    }}
                    readOnly={
                      !(modeOfTransfer === "ROUTE" || modeOfTransfer === "IFSC")
                    }
                    onKeyPress={(e) => allowOnlyAlphaNumerics(e)}
                    maxLength={11}
                    placeholder={
                      modeOfTransfer === "ROUTE"
                        ? t("pages.Add_Bene.routing_number", {
                            defaultValue: "Routing Number",
                          })
                        : modeOfTransfer === "IFSC"
                        ? t("pages.Add_Bene.ifsc_code", {
                            defaultValue: "IFSC Code",
                          })
                        : t("pages.Add_Bene.swift_or_bic", {
                            defaultValue: "Swift / BIC Code",
                          })
                    }
                    size="large"
                  />
                </Form.Item>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  name="bankName"
                  label={t("pages.standing_instruction.beneficiary_bank", {
                    defaultValue: "Beneficiary Bank",
                  })}
                  rules={[
                    {
                      required: true,
                      message: t(
                        "pages.standing_instruction.beneficiary_bank_req_txt",
                        {
                          defaultValue: "Beneficiary Bank is required",
                        }
                      ),
                    },
                  ]}
                >
                  <Input
                    maxLength={30}
                    placeholder={t(
                      "pages.standing_instruction.beneficiary_bank",
                      {
                        defaultValue: "Beneficiary Bank",
                      }
                    )}
                    size="large"
                    readOnly={
                      !(modeOfTransfer === "ROUTE" || modeOfTransfer === "IFSC")
                    }
                  />
                </Form.Item>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  name="bankCountry"
                  label={t("pages.Add_Bene.bank_country", {
                    defaultValue: "Bank Country",
                  })}
                  rules={[
                    {
                      required: true,
                      message: t("pages.Add_Bene.bank_country_req", {
                        defaultValue: "Bank Country is required",
                      }),
                    },
                  ]}
                >
                  <Input
                    placeholder={t("pages.Add_Bene.bank_country", {
                      defaultValue: "Bank Country",
                    })}
                    size="large"
                    readOnly={
                      !(modeOfTransfer === "ROUTE" || modeOfTransfer === "IFSC")
                    }
                  />
                </Form.Item>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Form.Item
                  name="bankAddress"
                  label={t("pages.Add_Bene.bank_address", {
                    defaultValue: "Bank Address",
                  })}
                  rules={[
                    {
                      required: true,
                      message: t("pages.Add_Bene.bank_address_req", {
                        defaultValue: "Bank Address is required",
                      }),
                    },
                  ]}
                >
                  <Input
                    maxLength={30}
                    placeholder={t("pages.Add_Bene.bank_address", {
                      defaultValue: "Bank Address",
                    })}
                    size="large"
                    readOnly={
                      !(modeOfTransfer === "ROUTE" || modeOfTransfer === "IFSC")
                    }
                  />
                </Form.Item>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  name="intermediaryBic"
                  label={t("pages.Add_Bene.intermediary_bic", {
                    defaultValue: "Intermediary Bic",
                  })}
                  rules={[
                    {
                      required: false,
                      message: t("pages.Add_Bene.intermediary_bic_req", {
                        defaultValue: "Intermediary Bic is required",
                      }),
                    },
                  ]}
                >
                  <Input
                    maxLength={30}
                    placeholder={t("pages.Add_Bene.intermediary_bic", {
                      defaultValue: "Intermediary Bic",
                    })}
                    size="large"
                  />
                </Form.Item>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  name="intermediaryBank"
                  label={t("pages.Add_Bene.intermediary_bank_name", {
                    defaultValue: "Intermediary Bank Name",
                  })}
                  rules={[
                    {
                      required: false,
                      message: t("pages.Add_Bene.intermediary_bank_name_req", {
                        defaultValue: "Intermediary Bank Name is required",
                      }),
                    },
                  ]}
                >
                  <Input
                    maxLength={30}
                    placeholder={t("pages.Add_Bene.intermediary_bank_name", {
                      defaultValue: "Intermediary Bank Name",
                    })}
                    size="large"
                  />
                </Form.Item>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  label={t("pages.fundtransfer.transaction_curr", {
                    defaultValue: "Transaction Currency",
                  })}
                  name={"txnCcy"}
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.trans_currency_require", {
                        defaultValue: "Transaction Currency is required",
                      }),
                    },
                  ]}
                >
                  <Select
                    placeholder={t(
                      "pages.fundtransfer.select_transaction_curr",
                      {
                        defaultValue: "Select Transaction Currency",
                      }
                    )}
                    bordered={true}
                    size="large"
                    onChange={(e) => {
                      form.setFieldsValue({ amount: "" });
                      setConvertedAmount({});
                    }}
                  >
                    {txnCurrencyList.map((option, idx) => (
                      <Select.Option key={idx} value={option.currencyCode}>
                        {option.currencyCode}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  label={t("common.amount", {
                    defaultValue: "Amount",
                  })}
                  name={"amount"}
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.amount_required", {
                        defaultValue: "Amount is required",
                      }),
                    },
                    {
                      validator: (_, value) => {
                        if (parseFloat(value) <= 0) {
                          return Promise.reject(
                            t("errorMesssages.amount_valid", {
                              defaultValue: "Amount should be greater than 0",
                            })
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <NumericFormat
                    type="tel"
                    // addonAfter={txnCurrency}
                    placeholder={t("common.amount", {
                      defaultValue: "Amount",
                    })}
                    maxLength={12}
                    allowNegative={false}
                    customInput={Input}
                    thousandSeparator={true}
                    fixedDecimalScale={false}
                    onKeyPress={(e) => allowDecimalwithMaxLimit(e)}
                    onBlur={(e) => {
                      e.target.value.length > 0 && getConvertedAmount();
                    }}
                    onChange={() => setConvertedAmount({})}
                    size="large"
                  />
                </Form.Item>
                {Object.keys(convertedAmount).length !== 0 && (
                  <div className="row mb-2">
                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                      <label className="mb-1">
                        {convertedAmount?.prefferedRate === true
                          ? t(
                              "pages.sendMoney.common_sendMoney.preffered_rate",
                              {
                                defaultValue: "Preffered Rate",
                              }
                            )
                          : t(
                              "pages.sendMoney.common_sendMoney.exchange_rate",
                              {
                                defaultValue: "Exchange Rate",
                              }
                            )}
                      </label>{" "}
                      <br />
                      <span>
                        1 {selectedAccount?.accountCurrency} ={" "}
                        {selectedTxnCcy + " " + convertedAmount.convRate}
                      </span>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                      <label className="mb-1">
                        {" "}
                        {t("pages.sendMoney.common_sendMoney.deducted_amount", {
                          defaultValue: "Deducted Amount",
                        })}
                      </label>
                      <br />
                      <span>{convertedAmount.deductedAmt}</span>
                    </div>
                  </div>
                )}
              </div>

              <span
                className="d-block mb-3 "
                style={{ textAlign: "left", cursor: "pointer" }}
              >
                {/* {showAdvanced && (
                <>
                  <HiOutlineMinusSmall />
                  {t("pages.fundtransfer.payment_options", {
                    defaultValue: "Payment Options",
                  })}
                </>
              )} */}

                {t("pages.fundtransfer.payment_options", {
                  defaultValue: "Payment Options",
                })}
              </span>

              <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-5 col-xl-5">
                  <Form.Item
                    label=""
                    name={"paymentType"}
                    style={
                      paymentType === "RECURRING"
                        ? { marginBottom: 20 }
                        : { marginBottom: 5 }
                    }
                  >
                    <Radio.Group
                      onChange={(e) => setPaymentType(e.target.value)}
                    >
                      <Radio value={"ONCE"}>
                        {t("pages.fundtransfer.one_time", {
                          defaultValue: "One Time",
                        })}
                      </Radio>
                      <Radio value={"RECURRING"}>
                        {t("pages.fundtransfer.recurring", {
                          defaultValue: "Recurring",
                        })}
                      </Radio>
                    </Radio.Group>
                  </Form.Item>
                  {paymentType === "ONCE" && (
                    <Form.Item label="" name={"paymentSubType"}>
                      <Radio.Group
                        onChange={(e) => setPaymentSubType(e.target.value)}
                      >
                        <Radio value={"Pay_Now"}>
                          {t("pages.fundtransfer.pay_now", {
                            defaultValue: "Pay Now",
                          })}
                        </Radio>
                        <Radio value={"Pay_Later"}>
                          {t("pages.fundtransfer.pay_latter", {
                            defaultValue: "Pay Later",
                          })}
                        </Radio>
                      </Radio.Group>
                    </Form.Item>
                  )}
                </div>
              </div>

              {paymentType === "ONCE" && paymentSubType === "Pay_Later" && (
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <Form.Item
                    label={t("pages.sendMoney.common_sendMoney.date", {
                      defaultValue: "Date",
                    })}
                    name={"frequencyDate"}
                    style={{ width: "100%" }}
                    rules={[
                      {
                        required: true,
                        message: t("errorMesssages.date_require", {
                          defaultValue: "Date is required",
                        }),
                      },
                    ]}
                  >
                    <DatePicker
                      // inputReadOnly={true}
                      allowClear={false}
                      showToday={false}
                      disabledDate={(current) => {
                        return (
                          dayjs().add(0, "days") >= current ||
                          dayjs().add(1, "month") <= current
                        );
                      }}
                      placeholder="DD-MM-YYYY"
                      // format={"DD-MM-YYYY"}
                      // format={"DD-MM-YYYY"}
                      format={{
                        format: "DD-MM-YYYY",
                        type: "mask",
                      }}
                      size="large"
                    />
                  </Form.Item>
                </div>
              )}

              {paymentType === "RECURRING" && (
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                  <Form.Item
                    label={t("pages.fundtransfer.no_of_instal", {
                      defaultValue: "Number of installment",
                    })}
                    name={"numberOfInstallment"}
                    rules={[
                      {
                        required: true,
                        message: t("errorMesssages.no_insdtall_require", {
                          defaultValue: "Number of installment is required",
                        }),
                      },
                    ]}
                  >
                    <Select
                      placeholder={t("pages.fundtransfer.no_of_instal", {
                        defaultValue: "Number of installment",
                      })}
                      bordered={true}
                      size="large"
                    >
                      {metaData.maximumInstallments.map((option, idx) => (
                        <Select.Option key={idx} value={option}>
                          {option}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              )}

              {paymentType === "RECURRING" && (
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                  <Form.Item
                    label={t("pages.fundtransfer.frequency", {
                      defaultValue: "Frequency",
                    })}
                    name={"frequency"}
                    rules={[
                      {
                        required: true,
                        message: t("errorMesssages.freq_requir", {
                          defaultValue: "Frequency is required",
                        }),
                      },
                    ]}
                  >
                    <Select
                      placeholder={t("pages.fundtransfer.frequency", {
                        defaultValue: "Frequency",
                      })}
                      bordered={true}
                      size="large"
                    >
                      {metaData.frequency.map((option, idx) => (
                        <Select.Option key={idx} value={option}>
                          {option}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              )}

              {paymentType === "RECURRING" && (
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                  <Form.Item
                    label={t("pages.common.start_date", {
                      defaultValue: "Start Date",
                    })}
                    name={"frequencyDate"}
                    style={{ width: "100%" }}
                    rules={[
                      {
                        required: true,
                        message: t("errorMesssages.start_date_require", {
                          defaultValue: "Start Date is required",
                        }),
                      },
                    ]}
                  >
                    <DatePicker
                      // inputReadOnly={true}
                      allowClear={false}
                      showToday={false}
                      disabledDate={(current) => {
                        return (
                          dayjs().add(0, "days") >= current ||
                          dayjs().add(1, "month") <= current
                        );
                      }}
                      placeholder="DD-MM-YYYY"
                      // format={"DD-MM-YYYY"}
                      format={{
                        format: "DD-MM-YYYY",
                        type: "mask",
                      }}
                      size="large"
                    />
                  </Form.Item>
                </div>
              )}

              {form?.getFieldValue("txnCcy") !==
                selectedAccount?.accountCurrency && (
                <Form.Item
                  label={""}
                  name={"hasFxDeal"}
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.has_fx_deal_require", {
                        defaultValue: "Has Fx Deal is required",
                      }),
                    },
                  ]}
                >
                  <span style={{ marginRight: "10px" }}>
                    <span className="asterisk-mark">*</span>
                    {t("pages.fundtransfer.hasfx", {
                      defaultValue: "Has Fx Deal ?",
                    })}
                  </span>
                  <Radio.Group
                    onChange={(e) => setHasFxDeal(e.target.value)}
                    value={hasFxDeal}
                  >
                    <Radio value={true}>
                      {t("buttons.yes_btn", {
                        defaultValue: "Yes",
                      })}
                    </Radio>
                    <Radio value={false}>
                      {t("buttons.no_btn", {
                        defaultValue: "No",
                      })}
                    </Radio>
                  </Radio.Group>
                </Form.Item>
              )}

              {hasFxDeal && (
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <Form.Item
                    label={t("pages.fundtransfer.fxno", {
                      defaultValue: "Fx Ref Number",
                    })}
                    name={"fxDealRefNo"}
                    rules={[
                      {
                        required: true,
                        message: t("errorMesssages.fx_ref_num_require", {
                          defaultValue: "Fx Ref Number is required",
                        }),
                      },
                    ]}
                  >
                    <Input
                      onKeyPress={(e) => allowOnlyAlphaNumerics(e)}
                      maxLength={30}
                      placeholder={t("pages.fundtransfer.fxno", {
                        defaultValue: "Fx Ref Number",
                      })}
                      size="large"
                      onBlur={(e) =>
                        e.target.value.length > 0 && getConvertedAmount()
                      }
                    />
                  </Form.Item>
                </div>
              )}

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Form.Item
                  label={t("pages.sendMoney.payee.upload_files", {
                    defaultValue: "Upload Files",
                  })}
                  name="file"
                  rules={[
                    {
                      required: true,
                      message: t("pages.sendMoney.payee.upload_files_req", {
                        defaultValue: "Upload Files are required",
                      }),
                    },
                  ]}
                >
                  <Dragger
                    accept="application/pdf"
                    height={100}
                    multiple={false}
                    listType={"picture"}
                    onChange={onChange}
                    onRemove={onRemove}
                    customRequest={handleAction}
                    maxCount={2}
                  >
                    <p className="ant-upload-text" style={{ fontSize: 12 }}>
                      {t("common.click_drag_to_upload", {
                        defaultValue:
                          "Click or drag file to this area to upload",
                      })}
                    </p>
                  </Dragger>
                </Form.Item>
              </div>

              {modifyVisible && (
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
                  <span className="text-bold">{allFiles.join(", ")}</span>
                </div>
              )}

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Form.Item
                  name="remarks"
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.remark_require", {
                        defaultValue: "Reason is required",
                      }),
                    },
                  ]}
                  label={t("common.remarks", {
                    defaultValue: "Reason",
                  })}
                >
                  <Input
                    placeholder={t("common.remarks", {
                      defaultValue: "Reason",
                    })}
                    size="large"
                    onKeyPress={(e) =>
                      allowOnlyAlphaNumericsShouldNotStartWithSpace(e)
                    }
                    maxLength={30}
                  />
                </Form.Item>
              </div>
            </div>

            <div className="bene-btn-group-container  mt-3">
              <div onClick={() => setAddBene(!addBene)} className="mt-1">
                {accountDetails?.beneExists !== true && (
                  <>
                    {" "}
                    <span style={{ marginRight: "5px ", cursor: "pointer" }}>
                      {addBene ? (
                        <img
                          src={checkedIcon}
                          alt="checked"
                          width={17}
                          height={17}
                          className="checked"
                        />
                      ) : (
                        <img
                          src={unCheckedIcon}
                          alt="unchecked"
                          width={17}
                          height={17}
                          className="unchecked"
                        />
                      )}
                    </span>
                    {t("pages.Add_Bene.title", {
                      defaultValue: "Add Beneficiary",
                    })}
                  </>
                )}
              </div>
              <div className="btn-group-container-style">
                <Button
                  onClick={() => navigate("/send-money")}
                  type="default"
                  className="secondary-btn"
                  style={{ marginRight: 20 }}
                  size="large"
                >
                  {t("buttons.cancel_btn", {
                    defaultValue: "Cancel",
                  })}
                </Button>
                {transferType === "TISS" || transferType === "EFT" ? (
                  <Button
                    type="primary"
                    className="primary-btn"
                    htmlType="submit"
                    size="large"
                  >
                    {t("buttons.submit_btn", {
                      defaultValue: "Submit",
                    })}
                  </Button>
                ) : (
                  <Button
                    type="primary"
                    className="primary-btn"
                    htmlType="submit"
                    size="large"
                  >
                    {t("buttons.submit_btn", {
                      defaultValue: "Submit",
                    })}
                  </Button>
                )}
              </div>
            </div>
          </Form>
        </div>
      </>
    );
  }

  function renderConfirm() {
    return (
      <>
        <h5 className="mb-3">
          {t("common.confirmation", {
            defaultValue: "Confirmation",
          })}
        </h5>

        <p className="mb-3" style={{ fontSize: 14 }}>
          {t("pages.sendMoney.payee.payment_txt", {
            defaultValue:
              "Please check the payment details carefully, before you proceed",
          })}
        </p>

        <div className="row">
          <div className="d-flex align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <AccountDisplayView />
            </div>
          </div>
        </div>

        <div className="confirm-details">
          <div className="row">
            <div className="confirm-label-wrapper">
              <label>
                {t("common.destination_account", {
                  defaultValue: "Destination Account",
                })}
              </label>
              <span>{formDetails?.destAcct}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.Add_Bene.bane_name", {
                  defaultValue: "Beneficiary Name",
                })}
              </label>
              <span>{formDetails?.beneName || "-"}</span>
            </div>
            <div className="confirm-label-wrapper">
              <label>
                {t("pages.payment_history.transfer_type", {
                  defaultValue: "Transfer Type",
                })}
              </label>
              <span>{formDetails?.txnType === "SWIFT" && "INTERNATIONAL"}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.fundtransfer.transaction_curr", {
                  defaultValue: "Transaction Currency",
                })}
              </label>
              <span>{formDetails?.txnCcy}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {t("common.amount", {
                  defaultValue: "Amount",
                })}
              </label>
              <span>{amountFormat(formDetails?.amount, selectedTxnCcy)}</span>
            </div>
            {Object.keys(convertedAmount).length !== 0 ? (
              <>
                <div className="confirm-label-wrapper">
                  <label>
                    {" "}
                    {t("pages.sendMoney.common_sendMoney.deducted_amount", {
                      defaultValue: "Deducted Amount",
                    })}
                  </label>
                  <span>{convertedAmount.deductedAmt}</span>
                </div>
              </>
            ) : null}

            {CONFIG?.PAYMENT_OPTION && (
              <div className="confirm-label-wrapper">
                <label>
                  {t("pages.view_scheduled_transfer.payment_type", {
                    defaultValue: "Payment Type",
                  })}
                </label>
                <span>
                  {metaData.paymentTypes[formDetails?.paymentType] ||
                    formDetails?.paymentType}
                </span>
              </div>
            )}

            {paymentType === "RECURRING" ? (
              <div className="confirm-label-wrapper">
                <label>
                  {t("pages.fundtransfer.no_of_instal", {
                    defaultValue: "Number of installment",
                  })}
                </label>
                <span>{formDetails?.numberOfInstallments || "-"}</span>
              </div>
            ) : null}

            {paymentType === "RECURRING" ? (
              <div className="confirm-label-wrapper">
                <label>
                  {t("pages.fundtransfer.frequency", {
                    defaultValue: "Frequency",
                  })}
                </label>
                <span>{formDetails?.frequency}</span>
              </div>
            ) : null}

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.sendMoney.common_sendMoney.date", {
                  defaultValue: "Date",
                })}
              </label>
              {paymentType === "ONCE" && paymentSubType === "Pay_Now" && (
                <span>{dayjs().format("DD-MM-YYYY")}</span>
              )}
              {paymentType === "ONCE" && paymentSubType === "Pay_Later" && (
                <span>
                  {dayjs(formDetails?.scheduledDate).format("DD-MM-YYYY")}
                </span>
              )}

              {paymentType === "RECURRING" && (
                <span>
                  {dayjs(formDetails?.scheduledDate).format("DD-MM-YYYY")}
                </span>
              )}
            </div>

            {hasFxDeal ? (
              <>
                <div className="confirm-label-wrapper">
                  <label>
                    {t("pages.fundtransfer.fxno", {
                      defaultValue: "Fx Ref Number",
                    })}
                  </label>
                  <span>{formDetails?.fxDealRefNo}</span>
                </div>
              </>
            ) : null}

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.login.address", {
                  defaultValue: "Address",
                })}
              </label>
              <span>{formDetails?.beneAddr}</span>
            </div>
            {/* <div className="confirm-label-wrapper">
              <label>Beneficiary Country</label>
              <span>{formDetails?.beneCountry}</span>
            </div> */}
            <div className="confirm-label-wrapper">
              <label>
                {t("pages.payment_history.mode_transfer", {
                  defaultValue: "Mode of Transfer",
                })}
              </label>
              <span>
                {
                  modeOfTransferList.find((e) => e.value === modeOfTransfer)
                    .label
                }
              </span>
            </div>
            <div className="confirm-label-wrapper">
              <label>
                {" "}
                {t("pages.standing_instruction.swift_code", {
                  defaultValue: "Swift Code",
                })}
              </label>
              <span>{formDetails?.swiftCode}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.standing_instruction.beneficiary_bank", {
                  defaultValue: "Beneficiary Bank",
                })}
              </label>
              <span>{formDetails?.destBankName}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.Add_Bene.bank_country", {
                  defaultValue: "Bank Country",
                })}{" "}
              </label>
              <span>{formDetails?.destBankCty}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.Add_Bene.bank_address", {
                  defaultValue: "Bank Address",
                })}{" "}
              </label>
              <span>{formDetails?.destBankAddr}</span>
            </div>

            {formDetails?.customFields?.cntrctSetlmtinterOne && (
              <div className="confirm-label-wrapper">
                <label>
                  {t("pages.Add_Bene.intermediary_bic", {
                    defaultValue: "Intermediary Bic",
                  })}
                </label>
                <span>{formDetails?.customFields?.cntrctSetlmtinterOne}</span>
              </div>
            )}

            {formDetails?.customFields?.intermediaryBank && (
              <div className="confirm-label-wrapper">
                <label>
                  {t("pages.Add_Bene.intermediary_bank_name", {
                    defaultValue: "Intermediary Bank Name",
                  })}
                </label>
                <span>{formDetails?.customFields?.intermediaryBank}</span>
              </div>
            )}

            <div className="confirm-label-wrapper">
              <label>Uploaded Files</label>
              <span>{allFiles.join(", ")}</span>
            </div>

            {accountDetails?.beneExists !== true && (
              <div className="confirm-label-wrapper">
                <label>
                  {t("pages.Add_Bene.title", {
                    defaultValue: "Add Beneficiary",
                  })}
                </label>
                <span>
                  {formDetails?.addBene
                    ? t("buttons.yes_btn", {
                        defaultValue: "Yes",
                      })
                    : t("buttons.no_btn", {
                        defaultValue: "No",
                      })}
                </span>
              </div>
            )}

            <div className="confirm-label-wrapper">
              <label>
                {t("common.remarks", {
                  defaultValue: "Reason",
                })}
              </label>
              <span>{formDetails?.remarksTag || "-"}</span>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-end mt-4">
          {/* <Button
            onClick={() => setCancelVisible(true)}
            type="default"
            style={{ marginRight: 30 }}
            className="secondary-btn"
            size="large"
          >
            {t("buttons.cancel_btn", {
              defaultValue: "Cancel",
            })}
          </Button> */}

          <Button
            onClick={() => {
              setStage(1);
              setModifyVisible(true);
            }}
            type="default"
            className="secondary-btn mx-3"
            size="large"
          >
            {t("buttons.back_btn", {
              defaultValue: "Back",
            })}
          </Button>
          <Button
            onClick={() => fundTransferVerify()}
            type="primary"
            className="primary-btn"
            size="large"
          >
            {t("buttons.proceed_btn", {
              defaultValue: "Proceed",
            })}
          </Button>
        </div>
      </>
    );
  }

  return (
    <>
      <Breadcrumb separator=">">
        {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
        <Breadcrumb.Item>
          <span onClick={() => navigate("/transfer")}>
            {t("navigation.transfer", {
              defaultValue: "Transfers",
            })}
          </span>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <span onClick={() => navigate("/send-money/quick-pay")}>
            {t("pages.sendMoney.payee.quick_transfer", {
              defaultValue: "Quick Transfer",
            })}
          </span>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <span>
            {t("navigation.international_transfer", {
              defaultValue: "International Transfer",
            })}
          </span>
        </Breadcrumb.Item>
      </Breadcrumb>
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <div className="d-flex" style={{ height: "25px" }}>
              <p className="title title-header hide-xs">
                {t("pages.sendMoney.payee.quick_transfer", {
                  defaultValue: "Quick Transfer",
                })}{" "}
              </p>
              <p className="Pipe hide-xs">|</p>
              <p className="beneTitle">
                {t("navigation.international_transfer", {
                  defaultValue: "International Transfer",
                })}
              </p>
            </div>
          </div>
        </div>
      </Card>

      <div className="row d-flex justify-content-between">
        {stage === 1 ? (
          <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 hide-xs">
            <Card className="application-card">
              <AccountCard />
            </Card>
          </div>
        ) : (
          <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 hide-xs">
            <Card className="application-card">
              <AccountSelectedCard />
            </Card>
          </div>
        )}
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
          <Card className="application-card card-padding">
            {renderSwitch()}
          </Card>
        </div>
      </div>

      <Modal
        title={"Swift Country Details"}
        open={swiftModalVisible}
        footer={null}
        width={830}
        closable={false}
        maskClosable={false}
        mask={true}
        centered
        // className="custom-error-modal"
      >
        <div style={{ margin: "0 auto" }}>
          <Form layout="vertical" form={swiftForm}>
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  name="swiftCountry"
                  label={t("pages.Add_Bene.country", {
                    defaultValue: "Country",
                  })}
                  rules={[
                    {
                      required: true,
                      message: t("pages.Add_Bene.country_is_required", {
                        defaultValue: "Country is required",
                      }),
                    },
                  ]}
                >
                  <Select
                    showSearch
                    optionFilterProp="children"
                    placeholder={t("pages.Add_Bene.country", {
                      defaultValue: "Country",
                    })}
                    onChange={(e) => getSwiftCodeLookUp(e)}
                  >
                    {swiftCountries.map((option, idx) => (
                      <Select.Option key={idx} value={option?.countryCode}>
                        {option?.countryName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  name="swiftBank"
                  label={t("pages.Add_Bene.bank", {
                    defaultValue: "Bank",
                  })}
                  rules={[
                    {
                      required: true,
                      message: t("pages.Add_Bene.bank_required", {
                        defaultValue: "Bank is required",
                      }),
                    },
                  ]}
                >
                  <Select
                    showSearch
                    optionFilterProp="children"
                    placeholder={t("pages.Add_Bene.bank", {
                      defaultValue: "Bank",
                    })}
                    disabled={swiftBankNameValues?.length > 0 ? false : true}
                    onChange={(value) => {
                      setSwiftCodeValues(
                        swiftBankNameValues.filter((e) => e.bankName === value)
                      );
                      setUpdatedSwiftCodeValues(
                        swiftBankNameValues.filter((e) => e.bankName === value)
                      );
                    }}
                  >
                    {swiftFilteredBank.map((option, idx) => (
                      <Select.Option key={idx} value={option?.bankName}>
                        {option?.bankName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  name="allCode"
                  label={t("pages.Add_Bene.search_swift_code", {
                    defaultValue: "Search Swift Code",
                  })}
                  rules={[
                    {
                      required: false,
                      message: t("pages.Add_Bene.bene_nick_name", {
                        defaultValue: "Swift Code is required",
                      }),
                    },
                  ]}
                >
                  <Input
                    placeholder={t("pages.Add_Bene.search_swift_code", {
                      defaultValue: "Search Swift Code",
                    })}
                    value={searchText}
                    onChange={(value) =>
                      handleSearchAndFilterChange(value.target.value)
                    }
                  />
                </Form.Item>
              </div>
            </div>
          </Form>

          {swiftCodeValues.length > 0 && (
            <div
              className="ft-table"
              style={{ height: "250px", overflow: "auto" }}
            >
              <table className="table">
                <thead style={{ backgroundColor: "#F1F1F1" }}>
                  <tr>
                    <th></th>
                    <th>
                      {" "}
                      {t("pages.standing_instruction.swift_code", {
                        defaultValue: "Swift Code",
                      })}
                    </th>
                    <th>
                      {t("pages.Add_Bene.country_name", {
                        defaultValue: "Country Name",
                      })}
                    </th>
                    <th>
                      {t("common.bank_name", {
                        defaultValue: "Bank Name",
                      })}
                    </th>
                    <th>
                      {t("pages.Add_Bene.bank_address", {
                        defaultValue: "Bank Address",
                      })}{" "}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {swiftCodeValues.map((option, idx) => (
                    <tr key={idx}>
                      <td>
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setIsChecked(true);
                            handleToggleCheck(idx, option?.swiftCode);
                          }}
                        >
                          {checkedIndex === idx ? (
                            <img
                              src={checkedIcon}
                              alt="checked"
                              width={17}
                              height={17}
                            />
                          ) : (
                            <img
                              src={unCheckedIcon}
                              alt="unchecked"
                              width={17}
                              height={17}
                            />
                          )}
                        </span>
                      </td>
                      <td>{option.swiftCode}</td>
                      <td
                        style={{
                          whiteSpace: "break-spaces",
                          wordBreak: " break-all",
                        }}
                      >
                        {option?.countryName}
                      </td>
                      <td
                        style={{
                          whiteSpace: "break-spaces",
                          wordBreak: " break-all",
                        }}
                      >
                        {option?.bankName}
                      </td>
                      <td
                        style={{
                          whiteSpace: "break-spaces",
                          wordBreak: " break-all",
                        }}
                      >
                        {option?.bankAddress}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <div className="d-flex justify-content-end">
            <Button
              onClick={() => {
                setSwiftModalVisible(false);
                setSwiftCountries([]);
                setSwiftBankNameValues([]);
                setSwiftCodeValues([]);
                setCheckedIndex("");
                setIsChecked(false);
                setSwiftFilteredBank([]);
                swiftForm.resetFields();
              }}
              type="default"
              size="large"
              className="secondary-btn mx-3"
            >
              {t("buttons.cancel_btn", {
                defaultValue: "Cancel",
              })}
            </Button>
            <Button
              type="primary"
              className="primary-btn"
              onClick={() => {
                setSwiftModalVisible(false);
                setSwiftCountries([]);
                setSwiftBankNameValues([]);
                setSwiftCodeValues([]);
                setCheckedIndex("");
                setIsChecked(false);
                setSwiftFilteredBank([]);
                swiftForm.resetFields();
              }}
              size="large"
              disabled={isChecked ? false : true}
            >
              {t("buttons.proceed_btn", {
                defaultValue: "Proceed",
              })}{" "}
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        title={t("pages.sendMoney.payee.quick_transfer", {
          defaultValue: "Cancel transfer?",
        })}
        open={cancelVisible}
        footer={null}
        width={350}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <p style={{ marginBottom: 30, fontSize: 15 }}>
          {t("pages.otp.quitCancelTitle", {
            defaultValue:
              " If you cancel this transaction now, you will have to start over. Are you sure you want to cancel?",
          })}
        </p>
        <div className="mt-3" align="right">
          <Button
            className="secondary-btn"
            type="default"
            onClick={() => setCancelVisible(false)}
          >
            {t("buttons.no_btn", {
              defaultValue: "No",
            })}
          </Button>
          <Button
            type="primary"
            className="primary-btn"
            style={{ marginLeft: 20 }}
            onClick={() => {
              setCancelVisible(false);
              navigate("/transfer");
            }}
          >
            {t("buttons.yes_btn", {
              defaultValue: "Yes",
            })}
          </Button>
        </div>
      </Modal>

      <Modal
        title={t("errorMesssages.error", { defaultValue: "Error" })}
        open={visible}
        footer={null}
        width={350}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <p style={{ marginBottom: 30, fontSize: 15 }}>{message}</p>
        <div align="right" className="mt-3">
          <Button
            type="default"
            className="secondary-btn"
            onClick={() => {
              setVisible(false);
            }}
          >
            {t("buttons.okay_btn", {
              defaultValue: "Okay",
            })}
          </Button>
        </div>
      </Modal>

      <Modal
        title={""}
        open={successVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
        // className="custom-error-modal"
      >
        <div style={{ margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{respDetails?.message}</p>

          <div align="center">
            <Button
              size="large"
              style={{ width: 130 }}
              onClick={() => {
                setSuccessVisible(false);
                navigate("/transfer");
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
            {mode === "AA" &&
              paymentType === "ONCE" &&
              paymentSubType === "Pay_Now" && (
                <>
                  <Button
                    size="large"
                    onClick={() => {
                      handleDownload(respDetails);
                    }}
                    className="secondary-btn mx-4"
                  >
                    {t("buttons.download_btn", { defaultValue: "Download" })}
                  </Button>
                </>
              )}
          </div>
        </div>
      </Modal>

      <Modal
        open={isErrorModalVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
        className="custom-error-modal"
      >
        <div style={{ width: 380, margin: "0 auto" }} align="center">
          <VscError
            style={{ display: "block", margin: "10px 0" }}
            size={50}
            fill="#ff4d4f"
          />
          <h5 className="mb-3" style={{ color: "#ff4d4f" }}>
            {t("errorMesssages.error", { defaultValue: "Error" })}!
          </h5>
          <p style={{ marginBottom: 30, fontSize: 15 }}>
            {t("pages.sendMoney.payee.file_size_txt", {
              defaultValue: "File size should not be greater than",
            })}{" "}
            {metaData?.internationalFileUploadSize}
          </p>
          <div align="center">
            <Button
              onClick={() => {
                setIsErrorModalVisible(false);
              }}
              type="primary"
            >
              {t("buttons.close_btn", { defaultValue: "Close" })}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
